<template>
    <carousel :per-page="1" :navigationClickTargetSize="14" :loop="true"
              :autoplay="true" :autoplayTimeout="5000" :navigationEnabled="false" :paginationEnabled="false">
        <slide v-for="(element, index) in elements" :key="index" class="text-center col-xs-12">
            <div class="vueslide">
                <span v-html="element"></span>
            </div>
        </slide>
    </carousel>
</template>

<script>
    export default {
        props: ['elements'],
    }
</script>

<style scoped></style>